import { Component, OnInit } from '@angular/core';
import { environment } from 'src/environments/environment';
import { Noticias } from '../_model/Noticias';
import { NewsService } from '../_services/news.service';
import { faLayerGroup, faCircle, faPlus, faMinus } from '@fortawesome/free-solid-svg-icons';

@Component({
    selector: 'app-noticias',
    templateUrl: './noticias.component.html',
    styleUrls: ['./noticias.component.less'],
    standalone: false
})
export class NoticiasComponent implements OnInit {

  faLayerGroup = faLayerGroup;
  faCircle = faCircle;
  faPlus = faPlus;
  faMinus = faMinus;
  
  constructor(private news: NewsService) {}

  pm_ctrl: boolean = false;
  apiUrl: string = environment.apiUrl;
  current: number = 1;
  pags: number = 0;
  display: Noticias[] = [];
  noticias: Noticias[] = [];
  total: Noticias[] = [];

  months: any = {
    jan: false,
    fev: false,
    mar: false,
    abr: false,
    mai: false,
    jun: false,
    jul: false,
    ago: false,
    set: false,
    out: false,
    nov: false,
    dez: false
  };

  mFilter: number[] = [];

  year: number = new Date().getFullYear();

  ngOnInit() {
    this.news.list().subscribe((data: Noticias[]) => {
      data.forEach(it => {
        this.noticias.push(new Noticias(it));
        this.total.push(new Noticias(it));
      });
      this.pags = Math.floor(this.noticias.length / 8) + (this.noticias.length % 8 > 0 ? 1 : 0);
    });
  }

  changePM() {
    this.pm_ctrl = !this.pm_ctrl;
  }

  updateFilter() {
    if(this.months.jan){
      this.mFilter = this.mFilter.filter(x => x != 0);
      this.mFilter.push(0);
    }else{
      this.mFilter = this.mFilter.filter(x => x != 0);
    }
    if(this.months.fev){
      this.mFilter = this.mFilter.filter(x => x != 1);
      this.mFilter.push(1);
    }else{
      this.mFilter = this.mFilter.filter(x => x != 1);
    }
    if(this.months.mar){
      this.mFilter = this.mFilter.filter(x => x != 2);
      this.mFilter.push(2);
    }else{
      this.mFilter = this.mFilter.filter(x => x != 2);
    }
    if(this.months.abr){
      this.mFilter = this.mFilter.filter(x => x != 3);
      this.mFilter.push(3);
    }else{
      this.mFilter = this.mFilter.filter(x => x != 3);
    }
    if(this.months.mai){
      this.mFilter = this.mFilter.filter(x => x != 4);
      this.mFilter.push(4);
    }else{
      this.mFilter = this.mFilter.filter(x => x != 4);
    }
    if(this.months.jun){
      this.mFilter = this.mFilter.filter(x => x != 5);
      this.mFilter.push(5);
    }else{
      this.mFilter = this.mFilter.filter(x => x != 5);
    }
    if(this.months.jul){
      this.mFilter = this.mFilter.filter(x => x != 6);
      this.mFilter.push(6);
    }else{
      this.mFilter = this.mFilter.filter(x => x != 6);
    }
    if(this.months.ago){
      this.mFilter = this.mFilter.filter(x => x != 7);
      this.mFilter.push(7);
    }else{
      this.mFilter = this.mFilter.filter(x => x != 7);
    }
    if(this.months.set){
      this.mFilter = this.mFilter.filter(x => x != 8);
      this.mFilter.push(8);
    }else{
      this.mFilter = this.mFilter.filter(x => x != 8);
    }
    if(this.months.out){
      this.mFilter = this.mFilter.filter(x => x != 9);
      this.mFilter.push(9);
    }else{
      this.mFilter = this.mFilter.filter(x => x != 9);
    }
    if(this.months.nov){
      this.mFilter = this.mFilter.filter(x => x != 10);
      this.mFilter.push(10);
    }else{
      this.mFilter = this.mFilter.filter(x => x != 10);
    }
    if(this.months.dez){
      this.mFilter = this.mFilter.filter(x => x != 11);
      this.mFilter.push(11);
    }else{
      this.mFilter = this.mFilter.filter(x => x != 11);
    }
    this.noticias = [];
    var temp = [];
    this.mFilter.forEach(it => {
      temp = this.total.filter(x => x.created.getMonth() == it);
      temp.forEach(it => {
        this.noticias.push(new Noticias(it));
      });
    });
    if(this.mFilter.length == 0) {
      this.noticias = this.total;
    }
    if(this.year != 0 && this.year) {
      this.noticias = this.noticias.filter(x => x.created.getFullYear() == this.year);
    }
    this.pags = Math.floor(this.noticias.length / 8) + (this.noticias.length % 8 > 0 ? 1 : 0);
  }
}
